import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../components/ui/Modal.jsx'
import Button from '../../components/ui/Button.jsx'
import Icon from '../../components/ui/Icon.jsx'
import { useAuth } from '../../context/AuthContext.jsx'
import api from '../../lib/api.js'

/*
 * Terms acceptance gate — inventory §0. Shown (blocking) when a signed-in user
 * hasn't accepted the current terms/privacy. POST /auth/accept-terms, then
 * refresh the profile so the gate clears.
 */
export default function TermsAcceptanceDialog() {
  const { t } = useTranslation()
  const { fetchProfile, setUser } = useAuth()
  const [terms, setTerms] = useState(false)
  const [privacy, setPrivacy] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const accept = async () => {
    if (!terms || !privacy) return
    setBusy(true); setError('')
    try {
      await api.post('/auth/accept-terms', { accept_terms: true, accept_privacy: true, terms_version: '1.0' })
      const p = await fetchProfile(); if (p?.user) setUser(p.user)
    } catch (e) { setError(e?.response?.data?.error || t('terms.error')) } finally { setBusy(false) }
  }

  return (
    <Modal open maxWidth={520} closeOnBackdrop={false}>
      <div style={{ padding: 28 }}>
        <div style={{ width: 50, height: 50, borderRadius: '50%', background: 'var(--color-bg-lilac-strong)', color: 'var(--color-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14 }}><Icon name="shield" size={26} /></div>
        <h2 style={{ fontFamily: 'var(--font-title)', fontWeight: 700, fontSize: 20, color: 'var(--color-ink)', marginBottom: 6 }}>{t('terms.title')}</h2>
        <p style={{ color: 'var(--color-text)', fontSize: 14, marginBottom: 20 }}>{t('terms.intro')}</p>
        {error && <div role="alert" style={{ background: 'var(--color-danger-bg)', color: 'var(--color-danger)', border: '1px solid #f3c9c9', borderRadius: 10, padding: '9px 12px', fontSize: 13, marginBottom: 14 }}>{error}</div>}

        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 14, marginBottom: 12 }}>
          <input type="checkbox" checked={terms} onChange={(e) => setTerms(e.target.checked)} style={{ marginTop: 3 }} />
          <span>{t('terms.acceptTerms')} <Link to="/legal/cgu" target="_blank" style={{ color: 'var(--color-primary)', fontWeight: 600 }}>{t('register.terms')}</Link>.</span>
        </label>
        <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer', fontSize: 14, marginBottom: 22 }}>
          <input type="checkbox" checked={privacy} onChange={(e) => setPrivacy(e.target.checked)} style={{ marginTop: 3 }} />
          <span>{t('terms.acceptPrivacy')} <Link to="/legal/privacy" target="_blank" style={{ color: 'var(--color-primary)', fontWeight: 600 }}>{t('register.privacy')}</Link>.</span>
        </label>

        <Button variant="primary" icon="check" fullWidth loading={busy} disabled={!terms || !privacy} onClick={accept}>{t('terms.accept')}</Button>
      </div>
    </Modal>
  )
}
